<template>
  <div>
    <div v-if="loading">
      Loading...
    </div>
    <div v-else-if="currentPatientData" id="page-user-view">

      <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
        <span>El usuario con id: {{ $route.params.userId }} no fue encontrado. </span>
        <span>
          <!-- <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link> -->
        </span>
      </vs-alert>

      <div id="user-data" v-if="user_data2">

        <vx-card :title="`Paciente ${$route.params.userId}`" class="mb-base">

          <!-- Avatar -->
          <div class="vx-row">

            <!-- Avatar Col -->
            <div class="vx-col" id="avatar-col">
              <div class="img-container mb-4">
                <img src='/img/evoUser.6d7a9256.png' class="rounded w-full" />
              </div>
            </div>

            <!-- Informacion Personal -->
            <div class="vx-col flex-1" id="account-info-col-1">
              <table>
                <tr v-if="!editting">
                  <td class="font-semibold w-1/2">Nombre(s)</td>
                  <td> {{currentPatientData.first_name}} </td>
                </tr>
                <tr class="" v-if="editting">
                  <td>
                    <vs-input label="Nombre" placeholder="Nombre(s)" v-model="patientData.first_name"/>
                  </td>
                </tr>
                <tr v-if="!editting">
                  <td class="font-semibold">Apellido(s)</td>
                  <td> {{currentPatientData.last_name}} </td>
                </tr>
                <tr class="" v-if="editting">
                  <td>
                    <vs-input label="Apellido(s)" placeholder="Apellido(s)" v-model="patientData.last_name"/>
                  </td>
                </tr>
                <tr v-if="!editting">
                  <td class="font-semibold">Correo Electrónico</td>
                  <td> {{currentPatientData.email}} </td>
                </tr>
                <tr class="" v-if="editting">
                  <td>
                    <vs-input label="Correo Electrónico" placeholder="Correo" v-model="patientData.email"/>
                  </td>
                </tr>
              </table>
            </div>
            <!-- /Informacion Personal1 -->

            <!-- Information - Col 2 -->
            <div class="vx-col flex-1" id="account-info-col-2">
              <table>
                <tr v-if="!editting">
                  <td class="font-semibold">Celular:</td>
                  <td> {{currentPatientData.phone[0] ? currentPatientData.phone[0] : ''}} </td>
                </tr>
                <tr class="" v-if="editting">
                  <td>
                    <vs-input label="Celular" placeholder="Celular" v-model="patientData.phone[0]"/>
                  </td>
                </tr>
                <tr v-if="!editting">
                  <td class="font-semibold">Teléfono:</td>
                  <td> {{currentPatientData.phone[1] ? currentPatientData.phone[1] : ''}} </td>
                </tr>
                <tr class="" v-if="editting">
                  <td>
                    <vs-input label="Teléfono" placeholder="Teléfono" v-model="patientData.phone[1]"/>
                  </td>
                </tr>
                <tr v-if="!editting">
                  <td class="font-semibold">Estado:</td>
                  <td> {{currentPatientData.active ? 'Activo' : 'Pendiente de Activación'}} </td>
                </tr>
                <tr class="" v-if="editting">
                  <td>
                    <p class="ml-1" style="font-size: 13px">Estado</p>
                    <v-select 
                      :options="[ {name:'Pendiente', val: false}, {name:'Activo', val: true}]" 
                      :reduce="option => option.val" label="name"
                      :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="patientData.active" class="mb-4 md:mb-0" />
                  </td>
                </tr>
              </table>
            </div>
            <!-- /Information - Col 2 -->
            <div class="vx-col w-full flex items-end  mt-4" id="account-manage-buttons">
              
            </div>
            <vs-row class="mt-4 w-full">
              <vs-col class="flex items-end pr-5">
                <vs-button v-if="!editting" color="warning" icon-pack="feather" icon="icon-edit" class="flex inline ml-5" @click="editting = !editting">Editar</vs-button>
                <vs-button v-if="editting" color="danger" icon-pack="feather" icon="icon-arrow-left" class="flex inline ml-5" @click="editting = !editting">Cancelar</vs-button>
                <vs-button v-if="editting" color="success" icon-pack="feather" icon="icon-save" class="flex inline ml-5" @click="editPatient">Guardar</vs-button>
              </vs-col>
              
            </vs-row>
          </div>

        </vx-card>
        
        <!-- TABS -->
        <vx-card class="mt-6">
          <div>
              <div class="mt-5">
                <vs-tabs alignment="fixed">
                  <!-- Información General -->
                  <vs-tab label="Cuenta">
                    <!-- Cuenta  -->
                    <div>
                      <div class="vx-row mt-3">
                        <div class="vx-col w-full md:w-1/2">

                            <!-- Col Header -->
                            <div class="flex items-end mb-6 mt-3">
                              <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
                              <span class="leading-none font-medium">Información Personal</span>
                            </div>
                            <!-- Col Content -->
                            <div class="ml-4 py-6">
                              <table>
                                <tr>
                                  <td class="font-semibold pr-5">Fecha de nacimiento</td>
                                  <td v-if="!editting"> 
                                    {{ currentPatientData.dob ? 
                                      new Date(currentPatientData.dob).toLocaleDateString('es-ES', dateStringOptions) :
                                       'N/A'
                                    }}
                                  </td>
                                  <td v-if="editting">
                                    <datepicker 
                                      class="px-5 mb-4" placeholder="Seleccionar Fecha" format="yyyy-MM-dd" 
                                      v-model="patientData.dob"
                                    >
                                    </datepicker>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="font-semibold">Edad</td>
                                  <td>
                                    {{
                                      currentPatientData.dob ? 
                                      calculateAge(currentPatientData.dob)+' años' : 'N/A'
                                    }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="font-semibold">Sexo</td>
                                  <td v-if="!editting">
                                    {{
                                        currentPatientData.gender ?
                                          currentPatientData.gender.toUpperCase().substring(0,1) :
                                          'N/A'
                                    }}
                                  </td>
                                  <td v-if="editting">
                                    <ul class="ml-6">
                                      <li class="ml-3 mb-2">
                                        <vs-radio v-model="patientData.gender" name="sexo" v-validate="'required'" vs-value="male">
                                          Másculino
                                        </vs-radio>
                                      </li>
                                      <li class="ml-3 mb-2">
                                        <vs-radio v-model="patientData.gender" name="sexo" v-validate="'required'" vs-value="female">
                                          Femenino
                                        </vs-radio>
                                      </li>
                                    </ul>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="font-semibold">Tipo de sangre</td>
                                  <td v-if="!editting">
                                    {{ currentPatientData.meta && currentPatientData.meta.blood_type ? 
                                       currentPatientData.meta.blood_type :
                                       'N/A'
                                    }}
                                  </td>
                                  <td v-if="editting" class="flex items-center">
                                    <v-select :options="['A+','O+','AB+','A-','O-','B-','AB-']" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="patientMeta.blood_type" class="mb-4 md:mb-0" />
                                  </td>
                                </tr>
                                <tr>
                                  <td class="font-semibold">Estatura</td>
                                  <td v-if="!editting">
                                    {{ currentPatientData.meta && currentPatientData.meta.height ? 
                                       currentPatientData.meta.height+' Metros' :
                                       'N/A'
                                    }}
                                  </td>
                                  <td v-if="editting" class="flex items-center">
                                    <vs-input label="Estatura" class="inline" placeholder="Estatura" 
                                      v-model="patientMeta.height"
                                    />
                                    <p class=" ml-3 mt-4 inline">Metros</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="font-semibold">Peso</td>
                                  <td v-if="!editting">
                                    {{ currentPatientData.meta && currentPatientData.meta.weight ? 
                                       currentPatientData.meta.weight+' Libras' :
                                       'N/A'
                                    }}
                                  </td>
                                  <td v-if="editting" class="flex items-center">
                                    <vs-input label="Peso" class="inline" placeholder="Peso" 
                                      v-model="patientMeta.weight"
                                    />
                                    <p class=" ml-3 mt-4 inline">Libras</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="font-semibold">Identificación</td>
                                  <td v-if="!editting" >
                                    {{ currentPatientData.meta && currentPatientData.meta.personal_id ? 
                                       currentPatientData.meta.personal_id :
                                       'N/A'
                                    }}
                                  </td>
                                  <td v-if="editting" class="">
                                    <vs-input label="Identificación" class="inline" placeholder="Identificación" 
                                      v-model="patientMeta.personal_id"
                                    />
                                  </td>
                                </tr>
                              </table>
                            </div>

                        </div>
                        
                        <!-- Address Col -->
                        <div class="vx-col w-full md:w-1/2">

                            <!-- Col Header -->
                            <div class="flex items-end mb-6 mt-3">
                              <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-5 h-5" />
                              <span class="leading-none font-medium">Dirección</span>
                            </div>
                            
                            <!-- Col Content -->
                            <div class="ml-4 py-6">
                              <table>
                                <tr>
                                  <td class="font-semibold pr-5">Dirección Principal</td>
                                  <td v-if="!editting"> 
                                    {{ currentPatientData.address ? 
                                      currentPatientData.address :
                                       'Sin Definir'
                                    }}
                                  </td>
                                  <td v-if="editting">
                                      <vs-input class="w-full mt-4" label="Dirección Principal"  v-validate="'required'" name="direccion" v-model="patientData.address" />
                                      <span class="text-danger text-sm"  v-show="errors.has('direccion')">{{ errors.first('direccion') }}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="font-semibold pr-5">Dirección Complementaria</td>
                                  <td v-if="!editting">
                                    {{
                                      currentPatientData.address_2 ? 
                                      currentPatientData.address_2 : 'Sin Definir'
                                    }}
                                  </td>
                                  <td v-if="editting">
                                    <vs-input class="w-full mt-4" label="Dirección Complementaria"  v-validate="'required'" name="complementaria" v-model="patientData.address_2" />
                                    <span class="text-danger text-sm"  v-show="errors.has('complementaria')">{{ errors.first('complementaria') }}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="font-semibold pr-5">Zona</td>
                                  <td v-if="!editting">
                                    {{
                                      currentPatientData.zone ? 
                                      currentPatientData.zone : 'Sin Definir'
                                    }}
                                  </td>
                                  <td v-if="editting">
                                      <vs-input class="w-full mt-4" label="Zona"  v-validate="'required|numeric'" name="zona" v-model="patientData.zone" />
                                      <span class="text-danger text-sm"  v-show="errors.has('zona')">{{ errors.first('zona') }}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="font-semibold pr-5">Ciudad</td>
                                  <td v-if="!editting">
                                    {{
                                      currentPatientData.city ? 
                                      currentPatientData.city : 'Sin Definir'
                                    }}
                                  </td>
                                  <td v-if="editting">
                                      <vs-input class="w-full mt-4" label="Ciudad"  v-validate="'required|alpha'" name="ciudad" v-model="patientData.city" />
                                      <span class="text-danger text-sm"  v-show="errors.has('ciudad')">{{ errors.first('ciudad') }}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="font-semibold pr-5">País</td>
                                  <td v-if="!editting">
                                    {{
                                      currentPatientData.country ? 
                                      currentPatientData.country : 'Sin Definir'
                                    }}
                                  </td>
                                  <td v-if="editting">
                                      <vs-input class="w-full mt-4" label="País" v-validate="'required|alpha'" name="pais" v-model="patientData.country" />
                                      <span class="text-danger text-sm"  v-show="errors.has('pais')">{{ errors.first('pais') }}</span>
                                  </td>
                                </tr>
                              </table>
                            </div>
                        </div>
                      </div>
                      <vs-row class="mt-4 w-full">
                        <vs-col class="flex flex-col items-end pr-5">
                        </vs-col>
                      </vs-row>
                    </div>
                  </vs-tab>
                  <!-- Condición Médica -->
                  <vs-tab label="Condición Médica">
                    <div class="vx-row">
                      <div class="vx-col w-full pr-6">
                        <!-- Col Header -->
                        <div class="flex items-end mb-6 mt-4">
                          <feather-icon icon="ActivityIcon" class="mr-2" svgClasses="w-5 h-5" />
                          <span class="leading-none font-medium">Condición Médica</span>
                        </div>

                        <div class="ml-4 w-full">
                          <table class="w-full">
                            <tr>
                              <td class="font-semibold">Alergías</td>
                              <td v-if="!editting">
                                {{ currentPatientData.meta && currentPatientData.meta.allergyBool ? 
                                    'Si' :
                                    'No'
                                }}
                              </td>
                              <td  v-if="currentPatientData.meta && currentPatientData.meta.allergyBool && !editting">
                                <strong>Detalle: </strong>
                                {{ currentPatientData.meta && currentPatientData.meta.allergyVal ? 
                                    currentPatientData.meta.allergyVal :
                                    ''
                                }}
                              </td>
                              <td v-if="editting" class="flex">
                                <vs-switch color="success" class="" v-model="patientMeta.allergyBool">
                                    <span slot="on">Si </span>
                                    <span slot="off">No</span>
                                </vs-switch>
                                <vs-textarea v-model="patientMeta.allergyVal" label="Detalle Alergías" class="ml-5 inline" rows="1" />
                              </td>
                            </tr>
                            <tr>
                              <td class="font-semibold w-auto">Antecedentes de Cáncer</td>
                              <td v-if="!editting">
                                {{ currentPatientData.meta && currentPatientData.meta.cancerBool ? 
                                    'Si' :
                                    'No'
                                }}
                              </td>
                              <td  v-if="currentPatientData.meta && currentPatientData.meta.cancerBool && !editting">
                                <strong>Detalle: </strong>
                                {{ currentPatientData.meta && currentPatientData.meta.cancerVal ? 
                                    currentPatientData.meta.cancerVal :
                                    'N/A'
                                }}
                              </td>
                              <td v-if="editting" class="flex">
                                <vs-switch color="success" class="" v-model="patientMeta.cancerBool">
                                    <span slot="on">Si </span>
                                    <span slot="off">No</span>
                                </vs-switch>
                                <vs-textarea v-model="patientMeta.cancerVal" label="Antecedentes de Cáncer" class="ml-5 inline" rows="1" />
                              </td>
                            </tr>
                            <tr>
                              <td class="font-semibold">¿Fuma?</td>
                              <td v-if="!editting">
                                {{ currentPatientData.meta && currentPatientData.meta.smoke ? 
                                    'Si' :
                                    'No'
                                }}
                              </td>
                              <td  v-if="currentPatientData.meta && currentPatientData.meta.smoke && !editting">
                                <strong>Detalle: </strong>
                                {{ currentPatientData.meta && currentPatientData.meta.smokeDetail ? 
                                    currentPatientData.meta.smokeDetail :
                                    'N/A'
                                }}
                              </td>
                              <td v-if="editting" class="flex">
                                <vs-switch color="success" class="" v-model="patientMeta.smoke">
                                    <span slot="on">Si </span>
                                    <span slot="off">No</span>
                                </vs-switch>
                                <vs-textarea v-model="patientMeta.smokeDetail" label="¿Fuma?" class="ml-5 inline" rows="1" />
                              </td>
                            </tr>
                            <tr>
                              <td class="font-semibold">Medicamentos</td>
                              <td v-if="!editting">
                                {{ currentPatientData.meta && currentPatientData.meta.MedsBool ? 
                                    'Si' :
                                    'No'
                                }}
                              </td>
                              <td v-if="currentPatientData.meta && currentPatientData.meta.MedsBool && !editting">
                                <strong>Detalle: </strong>
                                {{ currentPatientData.meta && currentPatientData.meta.MedsVal ? 
                                    currentPatientData.meta.MedsVal :
                                    'N/A'
                                }}
                              </td>
                              <td v-if="editting" class="flex">
                                <vs-switch color="success" class="" v-model="patientMeta.MedsBool">
                                    <span slot="on">Si </span>
                                    <span slot="off">No</span>
                                </vs-switch>
                                <vs-textarea v-model="patientMeta.MedsVal" label="Detalle Medicamentos" class="ml-5 inline" rows="1" />
                              </td>
                            </tr>
                            <tr>
                              <td class="font-semibold">Tratamiento</td>
                              <td v-if="!editting">
                                {{ currentPatientData.meta && currentPatientData.meta.treatmentBool ? 
                                    'Si' :
                                    'No'
                                }}
                              </td>
                              <td v-if="currentPatientData.meta && currentPatientData.meta.treatmentBool && !editting">
                                <strong>Detalle: </strong>
                                {{ currentPatientData.meta && currentPatientData.meta.treatmentVal ? 
                                    currentPatientData.meta.treatmentVal :
                                    'N/A'
                                }}
                              </td>
                              <td v-if="editting" class="flex">
                                <vs-switch color="success" class="" v-model="patientMeta.treatmentBool">
                                    <span slot="on">Si </span>
                                    <span slot="off">No</span>
                                </vs-switch>
                                <vs-textarea v-model="patientMeta.treatmentVal" label="Detalle Tratamiento" class="ml-5 inline" rows="1" />
                              </td>
                            </tr>
                            <tr>
                              <td class="font-semibold">Condición</td>
                              <td v-if="!editting">
                                {{ currentPatientData.meta && currentPatientData.meta.conditionBool ? 
                                    'Si' :
                                    'No'
                                }}
                              </td>
                              <td v-if="currentPatientData.meta && currentPatientData.meta.conditionBool && !editting">
                                <strong>Detalle: </strong>
                                {{ currentPatientData.meta && currentPatientData.meta.conditionVal ? 
                                    currentPatientData.meta.conditionVal :
                                    'N/A'
                                }}
                              </td>
                              <td v-if="editting" class="flex">
                                <vs-switch color="success" class="" v-model="patientMeta.conditionBool">
                                    <span slot="on">Si </span>
                                    <span slot="off">No</span>
                                </vs-switch>
                                <vs-textarea v-model="patientMeta.conditionVal" label="Detalle Condición" class="ml-5 inline" rows="1" />
                              </td>
                            </tr>
                            <tr>
                              <td class="font-semibold">Cirugias</td>
                              <td v-if="!editting">
                                {{ currentPatientData.meta && currentPatientData.meta.surgeryBool ? 
                                    'Si' :
                                    'No'
                                }}
                              </td>
                              <td v-if="currentPatientData.meta && currentPatientData.meta.surgeryBool && !editting">
                                <strong>Detalle: </strong>
                                {{ currentPatientData.meta && currentPatientData.meta.surgeryVal ? 
                                    currentPatientData.meta.surgeryVal :
                                    'N/A'
                                }}
                              </td>
                              <td v-if="editting" class="flex">
                                <vs-switch color="success" class="" v-model="patientMeta.surgeryBool">
                                    <span slot="on">Si </span>
                                    <span slot="off">No</span>
                                </vs-switch>
                                <vs-textarea v-model="patientMeta.surgeryVal" label="Detalle Cirugías" class="ml-5 inline" rows="1" />
                              </td>
                            </tr>
                            <tr>
                              <td class="font-semibold">Seguro</td>
                              <td v-if="!editting">
                                {{ currentPatientData.meta && currentPatientData.meta.insurance_plan ? 
                                    currentPatientData.meta.insurance_plan :
                                    'No'
                                }}
                              </td>
                              <td v-if="currentPatientData.meta && currentPatientData.meta.insurance_plan && !editting">
                                <strong>Detalle: </strong>
                                {{ currentPatientData.meta && currentPatientData.meta.insurance_num ? 
                                    currentPatientData.meta.insurance_num :
                                    'Sin detalle'
                                }}
                              </td>
                              <td v-if="editting" class="flex">
                                <vs-input class="inputx w-1/3 mr-5" placeholder="Aseguradora o plan médico" v-model="patientMeta.insurance_plan" />
                                <vs-input class="inputx w-2/3" placeholder="Póliza o número de afiliado" v-model="patientMeta.insurance_num" />
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </vs-tab>
                  <!-- Estadísticas -->
                  <vs-tab label="Estadísticas">
                    <div class="vx-row w-full">
                      <div class="vx-col w-1/3">
                        <vx-card title="Nivel de Azúcar" class="my-2">
                          <vue-apex-charts
                            type="line"
                            height="250"
                            :options="analyticsData.bloodSugar.chartOptions"
                            :series="analyticsData.bloodSugar.tempSeries"
                          />
                        </vx-card>
                      </div>
                      <div class="vx-col w-1/3">
                        <vx-card title="Presión Arterial" class="my-2">
                          <vue-apex-charts
                            type="line"
                            height="250"
                            :options="analyticsData.bloodPressure.chartOptions"
                            :series="analyticsData.bloodPressure.tempSeries"
                          />
                        </vx-card>
                      </div>
                      <div class="vx-col w-1/3">
                        <vx-card title="Nivel de Oxigeno" class="my-2">
                          <vue-apex-charts
                            type="line"
                            height="250"
                            :options="analyticsData.bloodOx.chartOptions"
                            :series="analyticsData.bloodOx.tempSeries"
                          />
                        </vx-card>
                      </div>
                      <div class="vx-col w-1/3">
                        <vx-card title="Pulso" class="my-2">
                          <vue-apex-charts
                            type="line"
                            height="250"
                            :options="analyticsData.bloodPulse.chartOptions"
                            :series="analyticsData.bloodPulse.tempSeries"
                          />
                        </vx-card>
                      </div>
                    </div>
                  </vs-tab>
                  <!-- Historial de Consultas -->
                  <vs-tab label="Historial de Consultas">
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <!-- Col Header -->
                        <div class="flex items-end mb-6">
                          <feather-icon icon="FolderIcon" class="mr-2" svgClasses="w-5 h-5" />
                          <span class="leading-none font-medium">Historial de Consultas</span>
                        </div>
                        <vx-consultation-list :consultationsList="allPatientEvents"></vx-consultation-list>
                        <!-- <div>
                          <table class="w-full">
                            <tr>
                              <th class="font-semibold text-base text-left px-3 py-2" v-for="heading in ['Id', 'Estado', 'Clinica', 'Receta', 'Horario', 'Fecha' , 'Ver']" :key="heading">{{ heading }}</th>
                            </tr>

                            <tr v-for="i in 10" :key="i">
                              <td class="px-3 py-2">
                                {{i}}
                              </td>
                              <td class="px-3 py-2">
                                <ul>
                                  <span class="flex items-center px-2 py-1 rounded">
                                    <div class="h-3 w-3 rounded-full mr-2 bg-success"></div>Activo
                                  </span>
                                </ul>
                              </td>
                              <td class="px-3 py-2">
                                Zona {{i}}
                              </td>
                              <td class="px-3 py-2">
                                <feather-icon icon="FileTextIcon" svgClasses="ml-5 h-6 w-6 stroke-current text-primary" />
                              </td>
                              <td class="px-3 py-2">
                                1{{i-1}}:00 AM
                              </td>
                              <td class="px-3 py-2">
                                1{{i-1}}/10/2020
                              </td>
                              <td class="px-3 py-2">
                                <feather-icon icon="EyeIcon" svgClasses="ml-5 h-6 w-6 stroke-current text-primary" />
                              </td>
                            </tr>
                          </table>
                        </div> -->

                      </div>
                    </div>
                  </vs-tab>
                </vs-tabs>
              </div>
          </div>
        </vx-card>

      </div>
      <vs-popup class="holamundo" fullscreen  title="Registro Extra" :active.sync="popupActive2">
        <div class="vx-row my-3">
          <div class="vx-col md:w-1/4 w-full">
            <h4>Registro de Expediente Extra</h4>
          </div>
        </div>
        <div class="vx-row mx-6 my-4">
          <div class="vx-col md:w-1/2 w-full flex">
            <vs-input class="w-full" label="Título" placeholder="Titulo" v-model="value1"/>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <p>Descripción</p>
            <vs-textarea label="Descripción" v-model="textarea" />
          </div>
        </div>
        <div class="vx-row mt-6 ">
          <div class="vx-col w-full">
            <h4>Archivos</h4>
          </div>
        </div>
        <div class="vx-row mx-6 my-4">
          <div class="vx-col w-full">
            <div class="excel-import">
              <input type="file" ref="fileInput" class="hidden" accept=".xlsx, .xls" @change="handleClick">
              <div
                
                @click="$refs.fileInput.click()"
                @drop="handleDrop"
                @dragover="handleDragover"
                @dragenter="handleDragover"
                class="px-8 py-16 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl"
                
                >
                <feather-icon icon="UploadCloudIcon" svgClasses="h-16 w-16 stroke-current text-grey" class="block" />
                <span>Arrastrar o</span>
                <span class="font-medium text-primary" @click.stop="$refs.fileInput.click()"> Buscar</span>
                <!-- <vs-button type="border" @click.stop="$refs.fileInput.click()">Browse</vs-button> -->
              </div>
            </div>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import vSelect from 'vue-select'
import analyticsData from '@/views/ui-elements/card/analyticsData.js'
// import ConsultationsListComponent from '@/views/consultations/consultationsListComponent.vue'
import VueApexCharts from 'vue-apexcharts'
import Datepicker from 'vuejs-datepicker';

export default {
  data () {
    return {
      loading: true,
      patientData: {},
      patientMeta: {
        height: null,
        weight: null,
        blood_type: null,
        personal_id: null,
        personal_id_type: null,
      },
      dateStringOptions:  { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      analyticsData,
      textarea: null,
      value1: null,
      user_data: null,
      user_data2: {
        names: 'Christian Jose',
        lastnames: 'Mayorga Fernandez',
        email: 'admin@mayfer.dev',
        emName: 'Lucas Mayorga',
        emPar: 'Padre',
        emNum: '+502 4562 4853',
        avatar: 'https://evolugy.mayfer.software/Evolugy/app-assets/images/portrait/small/avatar-s-11.jpg'
      },
      editting: false,
      edittingInG: false,
      user_not_found: false,
      popupActive2: false,
      users: [
        {
          "id": 1,
          "title": "Title",
          "desc": "Lorem ipsum dolor sit amet nulla pariatur.",
          "date": "10/12/2020",
          "type": "Archivo",
          "file": "Ficha-medica.dpf"
        }
      ]
    }
  },
  components: {
    ConsultationsListComponent: () => import('@/views/consultations/consultationsListComponent.vue'),
    vSelect,
    VueApexCharts,
    Datepicker
  },
  computed: {
    allPatientEvents() {
      if(this.$store.state.events) {
        const patientId = this.$route.params.userId;
        return this.$store.state.events.filter(event => event.patient_id == patientId);
      }
      return [];
    },
    userAddress () {
      let str = ''
      for (const field in this.user_data.location) {
        str += `${field  } `
      }
      return str
    },
    currentPatientData(){
      return this.$store.state.currentPatient
    }
  },
  watch: {
    allPatientEvents: function(data) {
      data = data.slice(-5);
      // Bloque de datos
      // Presion arterial
      const presionArterial = [];
      const presionArterialData = [{
              name: "Sistólica",
              data: []
          },
          {
              name: "Diastólica",
              data: []
          }
      ];
      const presionArterialCategories = [];
      // Niveles de Azúcar
      const nivelAzucar = [];
      const nivelAzucarData = [{
              name: "Nivel de Azúcar",
              data: []
          }
      ];
      const nivelAzucarCategories = [];
      // Nivel de Oxigeno
      const nivelOxigeno = [];
      const nivelOxigenoData = [{
              name: "Saturación de oxigeno",
              data: []
          }
      ];
      const nivelOxigenoCategories = [];
      // Pulso
      const pulso = [];
      const pulsoData = [{
              name: "Pulso",
              data: []
          }
      ];
      const pulsoCategories = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        presionArterialCategories.push(`# ${element.id}`);
        if(element.meta && Array.isArray(element.meta.vitalSigns)) {
          for (let indexMeta = 0; indexMeta < element.meta.vitalSigns.length; indexMeta++) {
            const vitalSign = element.meta.vitalSigns[indexMeta];
            switch (vitalSign.id) {
              case 1:
                presionArterial.push(vitalSign.options);
                break;
              case 2:
                  nivelAzucar.push(vitalSign.options);
                break;
              case 3:
                  nivelOxigeno.push(vitalSign.options);
                break;
              case 4:
                  pulso.push(vitalSign.options);
                break;
              default:
                break;
            }
          }
        }
      }
      // Presion arterial
      if (presionArterial.length) {
        for (let index = 0; index < presionArterial.length; index++) {
          const element = presionArterial[index];
          if(element[0] && element[0].name === 'Presión Sistólica') {
            presionArterialData[0].data.push(element[0].value);
          }
          if(element[1] && element[1].name === 'Presión Diastólica') {
            presionArterialData[1].data.push(element[1].value);
          }
        }
        // console.log(presionArterialData);
        // Data
        this.analyticsData.bloodPressure.tempSeries = [
          ... presionArterialData
        ];
        // Categories
        this.analyticsData.bloodPressure.chartOptions = { 
          ...this.analyticsData.bloodPressure.chartOptions,
          ...{
                xaxis: {
                    categories: presionArterialCategories
                }
            }
        };
      }
      // Nivel de Oxigeno
      if (nivelOxigeno.length) {
        for (let index = 0; index < nivelOxigeno.length; index++) {
          const element = nivelOxigeno[index];
          const dataValue = element.find(item => item.id === 2);
          if(dataValue) {
            nivelOxigenoData[0].data.push(dataValue.value);
          }
        }
        // Data
        this.analyticsData.bloodOx.tempSeries = [
          ... nivelOxigenoData
        ];
        // Categories
        this.analyticsData.bloodOx.chartOptions = { 
          ...this.analyticsData.bloodOx.chartOptions,
          ...{
                xaxis: {
                    categories: presionArterialCategories
                }
            }
        };
      }
      // Nivel de Azúcar
      if (nivelAzucar.length) {
        for (let index = 0; index < nivelAzucar.length; index++) {
          const element = nivelAzucar[index];
          const dataValue = element.find(item => item.id === 2);
          if(dataValue) {
            nivelAzucarData[0].data.push(dataValue.unit === 'mg/dL' 
              ? dataValue.value : (Number(dataValue.value)*18.018));
          }
        }
        // Data
        this.analyticsData.bloodSugar.tempSeries = [
          ... nivelAzucarData
        ];
        // Categories
        this.analyticsData.bloodSugar.chartOptions = { 
          ...this.analyticsData.bloodSugar.chartOptions,
          ...{
                xaxis: {
                    categories: presionArterialCategories
                }
            }
        };
      }
      // Pulso
      if (pulso.length) {
        for (let index = 0; index < pulso.length; index++) {
          const element = pulso[index];
          const dataValue = element.find(item => item.id === 2);
          if(dataValue) {
            pulsoData[0].data.push(dataValue.value);
          }
        }
        // Data
        this.analyticsData.bloodPulse.tempSeries = [
          ... pulsoData
        ];
        // Categories
        this.analyticsData.bloodPulse.chartOptions = { 
          ...this.analyticsData.bloodPulse.chartOptions,
          ...{
                xaxis: {
                    categories: presionArterialCategories
                }
            }
        };
      }
    }
  },
  methods: {
    editPatient(){
      this.editting = !this.editting;
      
      this.patientData.meta = this.patientMeta;

      this.$store.dispatch('editUser', this.patientData).then(response => {
            
            this.showAlert('success','Paciente Modificado','Paciente editado éxitosamente!');

            this.$store.dispatch('fetchPatient', this.patientData.id).then(response => {
              console.log(response);
              this.patientData = JSON.parse(JSON.stringify(response.data.data.user));
              if(response.data.data.user.meta){
                this.patientMeta = {...this.patientMeta, ...JSON.parse(JSON.stringify(response.data.data.user.meta))};
              }
            }, error => {
                console.error(error);
            }); 
            
        }, error => {
            console.error(error.response);
            this.showAlert('danger','Error al editar paciente',error.response.data.error);
        });
    },
    showAlert (color,title,text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text
      });
    },
    calculateAge(dob){
      var birth_year = dob.substring(0,4),
      birth_month = dob.substring(5,7),
      birth_day = dob.substring(8,10);
      
      var today_date = new Date(),
      today_year = today_date.getFullYear(),
      today_month = today_date.getMonth(),
      today_day = today_date.getDate(),
      age = today_year - birth_year;

      if ( today_month < (birth_month - 1))
      {
          age--;
      }
      if (((birth_month - 1) == today_month) && (today_day < birth_day))
      {
          age--;
      }
      return age;
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.user_data.username}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      this.$router.push({name:'app-user-list'})
      this.showDeleteSuccess()

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.user_data.id)
      //   .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    },
    getHeaderRow (sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C = undefined
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = `UNKNOWN ${  C}` // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    handleDragover (e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDrop (e) {
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'Only support uploading one file!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return
      }
      const rawFile = files[0] // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'Only supports upload .xlsx, .xls, .csv suffix files',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.uploadFile(rawFile)
    },
    readerData (rawFile) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: 'array' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const header = this.getHeaderRow(worksheet)
          const results = XLSX.utils.sheet_to_json(worksheet)
          const meta = { sheetName: firstSheetName }
          this.generateData({ header, results, meta })
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },
    handleClick (e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      this.uploadFile(rawFile)
    },
    isExcel (file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
    uploadFile (file) {
      this.$refs['fileInput'].value = null // fix can't select the same excel
      this.readerData(file)
    }
  },
  beforeMount(){

  },
  beforeCreate(){
    console.log(this.$route.params.userId);
    this.$store.dispatch('fetchEvents');
    const userId = this.$route.params.userId
    this.$store.dispatch('fetchPatient', userId).then(response => {
      console.log(response);
      this.patientData = JSON.parse(JSON.stringify(response.data.data.user));
      if(response.data.data.user.meta){
        this.patientMeta = {...this.patientMeta, ...JSON.parse(JSON.stringify(response.data.data.user.meta))};
      }
      this.loading = false;
    }, error => {
        console.error(error);
    }); 
  },
  created () {

  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>
